import { render, staticRenderFns } from "./InputCpf.vue?vue&type=template&id=4eb96874"
import script from "./InputCpf.vue?vue&type=script&lang=js"
export * from "./InputCpf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports